export class Translation {
  constructor(
    public id: string,
    public termId: string,
    public languageCode: string,
    public valueOne: string,
    public valueOther: string | null,
    public createdAt: string,
    public deletedAt: string | null = null
  ) {}

  static fromRow(row: Record<string, any>): Translation {
    return new Translation(
      row.id,
      row.term_id,
      row.language_code,
      row.value_one,
      row.value_other ?? null,
      row.created_at,
      row.deleted_at ?? null
    );
  }

  /** Whether this translation is fully complete for its associated term type */
  isComplete(isPlural: boolean): boolean {
    if (!this.valueOne || this.valueOne.trim() === "") return false;
    if (isPlural && (!this.valueOther || this.valueOther.trim() === "")) return false;
    return true;
  }
}

export default Translation;
